export default "__VITE_ASSET__839f04a7__"